import { ERROR_TIMEOUT_DELAY } from "client/utils/api";

export default function ($resource, $http, $rootScope, $timeout) {
  return {
    sidebarInfo: function (sidebar) {
      $rootScope.dataLoaded = false;
      $rootScope.errorFound = false;
      var testTimer = $timeout(function () {
        console.log('error timeout');
        $rootScope.errorFound = true;
      }, ERROR_TIMEOUT_DELAY);
      var sidebarInfo = $http.post('/users/sidebar', sidebar, { timeout: ERROR_TIMEOUT_DELAY });
      sidebarInfo.success(function (data) {
        console.log(data);
        $timeout.cancel(testTimer);
        $rootScope.dataLoaded = true;
      });
      sidebarInfo.error(function (data) {

      });
      return sidebarInfo;
    },
    geoInfo: function (geo) {
      var geoInfo = $http.post('geometry', geo);
      geoInfo.success(function (data) {

      });
      geoInfo.error(function (data) {

      });
      return geoInfo;
    },
    proxyInfo: function () {
      var proxyInfo = $http.get('/users/proxy', {timeout: 3000});
      proxyInfo.success(function (data) {

      });
      proxyInfo.error(function (data) {

      });
      return proxyInfo;
    },
    coverageInfo: function (coverage) {
      var coverageInfo = $http.post('/coverage', coverage);
      coverageInfo.success(function (data) {
        console.log(data);
      });
      return coverageInfo;
    }
  }
};



// WEBPACK FOOTER //
// ./client/services/Sidebar.js